module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/ko/5-1b7a8d7b040021b115531157389d2bf1.jpg";